import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'cboard.components.Board.ImageEditor.title',
    defaultMessage: 'Image editor'
  },
  rotateRight: {
    id: 'cboard.components.Board.ImageEditor.rotateRight',
    defaultMessage: 'Rotate right'
  },
  cropImage: {
    id: 'cboard.components.Board.ImageEditor.cropImage',
    defaultMessage: 'Crop image'
  },
  close: {
    id: 'cboard.components.Board.ImageEditor.close',
    defaultMessage: 'Close'
  },
  done: {
    id: 'cboard.components.Board.ImageEditor.done',
    defaultMessage: 'Done'
  },
  cancelCrop: {
    id: 'cboard.components.Board.ImageEditor.cancelCrop',
    defaultMessage: 'Cancel crop'
  },
  zoomIn: {
    id: 'cboard.components.Board.ImageEditor.zoomIn',
    defaultMessage: 'Zoom in'
  },
  zoomOut: {
    id: 'cboard.components.Board.ImageEditor.zoomOut',
    defaultMessage: 'Zoom out'
  }
});
